import http from 'hub-http/clients/apiClient';
import getTasksStore from 'getting-started-shared-tasks-store/store';
import { TourLifecycleState, getTourLifecycleMarkMetadata } from 'onboarding-tours-utils/lifecycleCore';
import retryClient from './api/retryClient';
import { setGroupKey } from './api/userContextApi';
import { setOnboardingSettings } from './onboardingSettings';
export const USER_CONTEXT_ACTIONS_BASE_URL = 'usercontext/v1/actions';
export const USER_CONTEXT_BASE_URL = 'usercontext/v1';

// Matches MULTI_PAGES_TOUR_KEY in onboarding-components/utils/multiPagesTourUtils
const CEM_MULTI_PAGES_TOUR_KEY = 'cem-multi-pages-tour';
// Matches MULTI_PAGES_TOUR_EXPIRES (30 mins)
const CEM_TOUR_TTL_MS = 30 * 60 * 1000;
const isCemTourActive = () => {
  try {
    const cemData = sessionStorage.getItem(CEM_MULTI_PAGES_TOUR_KEY);
    if (!cemData) {
      return false;
    }
    const parsed = JSON.parse(cemData);
    if (!(parsed !== null && parsed !== void 0 && parsed.id) || !(parsed !== null && parsed !== void 0 && parsed.timestamp)) {
      return false;
    }
    return Date.now() < parsed.timestamp + CEM_TOUR_TTL_MS;
  } catch (_unused) {
    return false;
  }
};
export const enableTaskCompletionModal = (actionName, options = {}) => {
  const {
    targetWindow = window
  } = options;
  try {
    const bannerFrame = targetWindow.document.getElementById('onboarding-tours-banner-frame');
    if (!window.sessionStorage || !bannerFrame || !bannerFrame.contentWindow) {
      return;
    }
    const configKey = 'ONBOARDING_TOURS_GUIDE';
    const configJson = window.sessionStorage.getItem(configKey);
    if (!configJson) {
      return;
    }
    const config = JSON.parse(configJson);
    if (config.type === 'task' && config.key === actionName) {
      config.completed = true;
      bannerFrame.contentWindow.postMessage({
        key: configKey,
        value: config
      }, '*');
    }
  } catch (e) {
    return;
  }
};
const getTaskDataSource = actionName => {
  try {
    var _getTasksStore$getTas;
    return (_getTasksStore$getTas = getTasksStore().getTaskStartedWithingTimeframe(actionName)) === null || _getTasksStore$getTas === void 0 ? void 0 : _getTasksStore$getTas.source;
  } catch (e) {
    return undefined;
  }
};

/**
 * Checks if a tour is currently in an active session.
 *
 * Uses the Performance API to check the tour lifecycle state. A tour is considered
 * "in session" if it's in any state except NO_TOUR, CONFIG_LOAD_ERROR,
 * TOUR_LOAD_CANCELLED, or TOUR_ENDED.
 *
 * @returns true if a tour is in an active session, false otherwise
 * @internal This is a local implementation using onboarding-tours-utils/lifecycleCore
 */
const isInTourSession = () => {
  const tourState = getTourLifecycleMarkMetadata();
  const nonSessionStates = [TourLifecycleState.NO_TOUR, TourLifecycleState.CONFIG_LOAD_ERROR, TourLifecycleState.TOUR_LOAD_CANCELLED, TourLifecycleState.TOUR_ENDED];
  return tourState !== null && !nonSessionStates.includes(tourState.state);
};

/**
 *  @param actionName task key
 *  @param options.showTaskCompletionModal show task completion modal from handholding banner
 */
export const markActionComplete = (actionName, options = {}) => {
  return retryClient.post(USER_CONTEXT_ACTIONS_BASE_URL, {
    data: {
      actionName,
      actionOrigin: getTaskDataSource(actionName)
    }
  }).then(() => {
    const {
      showTaskCompletionModal = true,
      targetMessageWindow = window,
      source
    } = options;
    if (!showTaskCompletionModal) {
      return;
    }

    /**
     * Ignore task completion modal for avoiding breaking onboarding tour when:
     *   - Any onboarding tour is active in current page
     *   - markActionComplete is not triggered from onboarding-tours lib
     * */
    if (source !== 'onboarding-tours' && (isInTourSession() || isCemTourActive())) {
      return;
    }
    enableTaskCompletionModal(actionName, {
      targetWindow: targetMessageWindow
    });
  });
};
export const getCompletedActions = () => http.get(USER_CONTEXT_ACTIONS_BASE_URL);
export const getIsActionCompleted = actionName => http.get(`${USER_CONTEXT_ACTIONS_BASE_URL}/${actionName}`);
export const getTasksGroup = () => {
  return http.get(`${USER_CONTEXT_BASE_URL}/onboarding/tasks/group`, {
    headers: {
      accept: 'text/plain'
    }
  });
};
export const setDefaultGroupKey = (groupKey, options) => setGroupKey(groupKey, options);
export const setGettingStartedGroupKey = (groupKey, view, userId, portalId) => {
  const groupKeyRequests = [setDefaultGroupKey(groupKey)];
  if (view && userId) {
    groupKeyRequests.push(setOnboardingSettings({
      views: {
        [view]: {
          groupKey
        }
      },
      selectedView: view
    }, userId, portalId));
  }
  return Promise.all(groupKeyRequests);
};